import styled from 'styled-components';

export const OptinFooterStyled = styled.p`
  font-family: Montserrat;
  font-size: 16px;
  line-height: 19px;
  padding-top: 24px;
  color: #616161;
`;
